import React, { useState, useEffect, useContext } from 'react'
import { get, post } from '../../lib/api'
import WBPSteps from './WBPSteps'
import {
  checkOverseasUser,
  getTokenAndUid,
  handleEventLog,
  handlePageLoadEventLog,
} from '../../lib/utils'
import { BookCard, MonthlyBookCard } from './Cards'
import OpenedNotifications from './openedNotification'
import Tracker from './Tracker'
import TNC from './termsAndConditions'
import DropDownSelect from '../../components/GenericDropDownSelect'
import { Box, Text } from '../../designSystem'
import { AccountContext } from '../../providers/accountProvider'
import CreateNew from '../Shows/Novels/CreateNew'
import VideoPlayer from '../../components/VideoPlayer'
import PlayIcon from '../../components/Images/PlayIcon'
import { getModuleOrTextAccordingToLocale, isMobileOrTablet } from './helpers'
import { clarity } from 'react-microsoft-clarity'
import DailyBonus from './NewWBPCards/dailyBonus'
import {
  widgetsContainer,
  videoContainer,
  VideoNotificationBanner,
  VideoNotification,
  PlayIconBtn,
  VideoBannerContent,
} from './style'
import Loader from '../../components/Loader'
import Contests from './contests'
import VideoPlayerCard from './Cards/videoPlayerCard'
import Banner from '../../components/Banner'
import PerformanceCard from './Cards/performanceCard'
import WhatsAppPopUp from './WhatsApp/WhatsAppPopUp'
import Carousel from '../../components/Carousel'
import LeaderboardTags from './leaderboardTags'
import Footer from '../../components/Footer'
import NewBookCards from './NewWBPCards/NewBookCards'
import { handleNewEventLog } from '../../lib/utils/events'
import WelcomePages from './OnboardingRevamp/WelcomePages'

const HomeUI = ({ history }) => {
  const [banners, setBanners] = useState([])
  const [isLoading, setLoading] = useState(true)
  const [WBPDetails, setWBPDetails] = useState(null)
  const [isMobile, setIsMobile] = useState(false)
  const [appliedNovelID, setAppliedNovelID] = useState(null)
  const [showTNC, setShowTNC] = useState(false)
  const [currentStep, setCurrentStep] = useState(1)
  const [openedNotification, setOpenedNotification] = useState(null)
  const [isTrackerShown, setIsTrackerShown] = useState(false)
  const [datesMissing, setDatesMissing] = useState([])
  const [hiddenIds, setHiddwnIds] = useState([])
  const [bookSelected, setBookSelected] = useState('')
  const [bookSelectedDetails, setBookSelectedDetails] = useState({})
  const [bookList, setBookList] = useState([])
  const { user, isUgcUser, isHindiUgcUser, isClarityEnabled, setClarityEnabled } = useContext(AccountContext)
  const [isShowAllContest, setIsShowAllContest] = useState(false)
  const [isUserNew, setIsUserNew] = useState(false) // check whether user is having books
  const [showVideo, setShowVideo] = useState(false)
  const [signingStatus, setSigningStatus] = useState('')
  const [showVideoNotification, setShowVideoNotification] = useState(false)
  const [isEditorialBannerVisible, serIsEditorialBannerVisible] =
    useState(false)
  const queryString = window.location.search
  const params = new URLSearchParams(queryString)
  const referrer = params.get('referrer')
  const binger_exp_varaint = params.get('exp_variant')
  const view = params.get('view')
  const urlBookId = params.get('entity_id') || localStorage.getItem('entity_id')
  const { books, author_name, is_program_user } = bookSelectedDetails
  let book = []
  if(books) book = books[0] 

  useEffect(() => {
    if (view === 'all-contests') {
      setIsShowAllContest(true)
    } else {
      setIsShowAllContest(false)
    }
  })

  useEffect(() => {
    if(!isClarityEnabled && process.env.REACT_APP_DEPLOY_ENV === 'production') {
      get(
        '/user_api/user.is_beta_release_enabled?is_novel=1&feature_name=clarity'
      )
        .then((res) => {
          if (res?.enable_clarity) {
            clarity.init('ljlweqt92o')
            setClarityEnabled(true);
          }
        })
        .catch((err) => {
          console.error(err)
        })
    }
  }, [])

  const updateBookSelected = async (bookId, type) => {
    const { uid } = getTokenAndUid()
    if (bookId) {
      const wbpDetails = await get(
        `/content_api/book.creator_ben_prog/?book_id=${bookId}&is_novel=1`
      )
      setBookSelectedDetails(wbpDetails)
      if(!type){
        handleNewEventLog('home','writer_home_novel_viewed',{route : window.location.pathname + window.location.search,module_name: 'home_novel_section'}, user, wbpDetails)
      }else{
        handleNewEventLog('home','writer_home_novel_clicked',{route : window.location.pathname + window.location.search,module_name: 'home_novel_section', button: 'novel_select_from_dropdown'}, user, wbpDetails)
      }
      if (!showVideoNotification && !wbpDetails.books[0].published)
        setShowVideoNotification(true)
      try {
        if (
          wbpDetails?.books.length > 0 &&
          wbpDetails?.books[0].application_status === 'pending'
        ) {
          const contractDetails = await get(
            `/contract/${bookId}/?uid=${uid}&is_novel=1`
          )
          setSigningStatus(contractDetails?.status)
        }
      } catch (error) {
        console.log(error)
      }
    }

    setBookSelected(bookId)
    let booksSelected = JSON.parse(localStorage.getItem('bookSelected')) || {}
    booksSelected = { ...booksSelected, [uid]: bookId }
    localStorage.setItem('bookSelected', JSON.stringify(booksSelected))
  }

  const sortBooksDateWise = (_books) =>
    _books.sort((a, b) => new Date(a.create_time) - new Date(b.create_time))

  const fetchBooks = async () => {
    get('/content_api/book.cbp_book_list?is_novel=1').then((response) => {
      const sortedBooks = sortBooksDateWise(response)
      setIsUserNew(response.length === 0)
      setBookList(response)
      serIsEditorialBannerVisible(
        response.findIndex((element) => element.status === 'approved') !== -1
      )
      let bookSelectedId = ''
      try {
        JSON.parse(localStorage.getItem('bookSelected'))
      } catch (e) {
        bookSelectedId = localStorage.getItem('bookSelected')
        localStorage.removeItem('bookSelected')
      }
      if (urlBookId) {
        const isUrlBookIdValid = response.filter(
          (_book) => _book.book_id === urlBookId
        )
        if (isUrlBookIdValid.length > 0) {
          updateBookSelected(urlBookId)
          return
        }
      }
      if (bookSelectedId !== '') {
        updateBookSelected(bookSelectedId)
      } else if (!localStorage.getItem('bookSelected')) {
        updateBookSelected(sortedBooks[0] ? sortedBooks[0].book_id : '')
      } else {
        const { uid } = getTokenAndUid()
        const novelSelected =
          JSON.parse(localStorage.getItem('bookSelected')) || {}
        const selectedNovelId = novelSelected[uid]
        if (!selectedNovelId) {
          updateBookSelected(sortedBooks[0] ? sortedBooks[0].book_id : '')
        } else if (
          sortedBooks.find(({ book_id }) => book_id === selectedNovelId)
        ) {
          updateBookSelected(selectedNovelId)
        } else {
          updateBookSelected(sortedBooks[0] ? sortedBooks[0].book_id : '')
        }
      }
    })
  }

  const fetchCBPBooks = async () => {
    await fetchBooks()
    await get('/content_api/book.creator_ben_prog/?is_novel=1').then(
      (response) => {
        setLoading(false)
        setWBPDetails(response)
      }
    ).catch(() => setLoading(false))
  }

  useEffect(() => {
    handleNewEventLog('home','writer_home_home_page_viewed',{route : window.location.pathname + window.location.search}, user)
    handlePageLoadEventLog('home')
    const { uid, token } = getTokenAndUid()
    localStorage.setItem('isLoggedIn', 'true')
    if (window.Android) {
      if (window.Android.onLoginSuccess) {
        console.log('Executed onLoginSuccess')
        window.Android.onLoginSuccess(uid || '', token || '')
      }
    } else {
      console.log('Function onLoginSuccess not exist')
    }
    if (window.webkit) {
      if (
        window.webkit.messageHandlers &&
        window.webkit.messageHandlers.onLoginSuccess
      ) {
        console.log('messageHandlers webkit.onLoginSuccess')
        window.webkit.messageHandlers.onLoginSuccess.postMessage({
          uid: uid || '',
          auth_token: token || '',
        })
      }
    }
    if (window.screen.width < 600) {
      setIsMobile(true)
    }
    fetchCBPBooks()
  }, [user])

  useEffect(() => {
    if (!user?.languages) return
    const isUSUser = isUgcUser || user?.location === 'US'
    if (!checkOverseasUser(user) || isUSUser) {
      get('/content_api/banners/writer_banners/', {
        params: {
          language: user.languages || 'hindi',
          is_novel: 1,
          locale: isUSUser ? 'US' : user?.location || 'IN',
        },
      }).then((_banners) => {
        setBanners(_banners)
      })
    }
  }, [user])

  useEffect(() => {
    if (
      (book.status === 'approved' || book.status === 'published') &&
      book?.program_type !== 'writer_benefit_v3'
    ) {
      handlePageLoadEventLog('home_novelperformance', {
        show_id: bookSelected ?? '',
      })
    }
  }, [bookSelected])

  const novelApply = (book_id) => {
    handleEventLog('home', 'button_click', {
      route: `${window.location.pathname}${window.location.search}/${book_id}`,
      button: 'apply_now',
    })
    setAppliedNovelID(book_id)
  }
  const viewApplication = (book_id) => {
    setAppliedNovelID(book_id)
    setCurrentStep(2)
  }
  const resetSteps = () => {
    setCurrentStep(1)
    setAppliedNovelID(null)
    setOpenedNotification(null)
    fetchCBPBooks()
  }
  const handleSetTracker = (dates) => {
    setDatesMissing(dates)
    setIsTrackerShown(true)
  }
  const hideCardAfterView = (id) => {
    setHiddwnIds([...hiddenIds, id])
  }
  const handleViewStatusClick = (program, dontOpenCard, setViewed) => {
    if (dontOpenCard) {
      if (setViewed) {
        const { uid } = getTokenAndUid()
        post('/content_api/book.user_application/?is_novel=1', {
          data: {
            uid,
            id: program.id,
            is_viewed: 1,
          },
        })
        hideCardAfterView(program.id)
      }
      return
    }
    setOpenedNotification(program)
  }

  const playVideoHandler = () => {
    if (!showVideo) setShowVideo(true)
  }

  const hideVideoContainerHandler = () => setShowVideo(false)

  if(isLoading) return <Loader />
  
  if (showTNC) {
    return <TNC dismissTerms={() => setShowTNC(false)} />
  }
  if (appliedNovelID) {
    return (
      <WBPSteps
        currentStep={currentStep}
        setCurrentStep={setCurrentStep}
        resetSteps={resetSteps}
        showTerms={() => setShowTNC(true)}
        book={book}
      />
    )
  }
  if (openedNotification) {
    return (
      <OpenedNotifications
        program={openedNotification}
        handleReset={resetSteps}
      />
    )
  }

  if (isUserNew && !binger_exp_varaint && user?.onboarding_revamp_variant === 'B') {
    return (
      <WelcomePages user={user} />
    )
  }

  if (isUserNew && (user.languages === 'hindi' || isUgcUser)) {
    return (
      <>
        {isMobileOrTablet() ? (
          <VideoPlayerCard user={user} history={history} referrer={referrer} bingerExpVaraint={binger_exp_varaint} />
        ) : (<>
          <CreateNew isHome user={user} />
          <Footer />
          </>
        )}
      </>
    )
  }

  return (
    <>
      {Number(user.is_writer_whatsapp_popup) === 1 && (
        <WhatsAppPopUp phone_number={user?.phone_number} />
      )}
      {isTrackerShown && (
        <Tracker
          isTrackerShown={isTrackerShown}
          closeTracker={() => setIsTrackerShown(false)}
          datesMissing={datesMissing}
        />
      )}
      {!isShowAllContest && (
        <Box {...widgetsContainer}>
          {user.languages === 'hindi' &&
            !isUserNew &&
            showVideoNotification && (
              <VideoNotificationBanner>
                <VideoNotification>
                  <PlayIconBtn onClick={playVideoHandler}>
                    <PlayIcon fill="#ae8701" />
                  </PlayIconBtn>
                  <VideoBannerContent>
                    Learn how to publish the novel in our Pocket Novels App
                  </VideoBannerContent>
                </VideoNotification>
              </VideoNotificationBanner>
            )}

          {user.languages === 'hindi' && showVideo && (
            <Box {...videoContainer}>
              <VideoPlayer
                videoSrc={getModuleOrTextAccordingToLocale(
                  user,
                  'videoTutorialSrc'
                )}
                videoType="video/mp4"
                hideVideoPlayer={hideVideoContainerHandler}
              />
            </Box>
          )}

          {!banners.length && isEditorialBannerVisible && (
            <Banner
              contentLink={
                user.languages === 'english'
                  ? 'https://blog.pocketnovel.com/category/english/'
                  : 'https://blog.pocketnovel.com/'
              }
              title="Hot events"
              bannerSrc="https://djhonz7dexnot.cloudfront.net/df4eb9e3973201e9c9c09610f6a2e47577f32293.jpg"
            />
          )}
          {banners.length > 0 && (
            <Carousel
              banners={banners}
              language={user?.languages}
              isUgcUser={isUgcUser}
              user={user}
            />
          )}
          {bookList.length > 0 ? (
            <Box
              display="flex"
              flexGrow="1"
              backgroundColor="surface.foreground"
              mb="8px"
              py={16}
              px={8}
            >
              {!isHindiUgcUser && <Box mx={[0, 16]}>
                <Text
                  varaint="titleMedium"
                  fontWeight="b"
                  fontSize={[20, 24]}
                  color="var( --azure)"
                  mr={8}
                  mt={8}
                  ml={4}
                >
                  {isUgcUser ? 'Series' : 'Novels'}({bookList.length})
                </Text>
              </Box>}
              <Box width={[isHindiUgcUser ? '100%' : '60vw', '49%']}>
                <DropDownSelect
                  name="book"
                  placeholder="Select a Book"
                  selectOptions={bookList}
                  idKey="book_id"
                  nameKey="book_title"
                  value={bookSelected}
                  isSeries={(WBPDetails?.books?.filter((book) => book?.book_id === bookSelected))?.[0]?.is_novel === 2}
                  books
                  clickOnSelect
                  onChange={(b) => updateBookSelected(b, 'change')}
                />
              </Box>
            </Box>
          ) : (
            <CreateNew user={user} isHome />
          )}
          {book?.book_id && (
            <React.Fragment key={book?.book_id}>
              {bookSelectedDetails?.author_ranks_data?.[0]?.book_id && (
                <LeaderboardTags
                  authorRankData={bookSelectedDetails?.author_ranks_data?.[0]}
                  contestData={book?.contest_data}
                  history={history}
                />
              )}
              {/* {(book.application_status !== 'ongoing' || (book.status === 'draft' || book.status === 'disabled')) && <BookCard
          book={book}
          novelApply={novelApply}
          viewApplication={viewApplication}
          is_program_user={is_program_user}
          isMobile={isMobile}
          totalBooks={bookList ? bookList.length : 0}
          resetAfterUnblock={reFetchBooks}
          signingStatus={signingStatus}
        />} */}
              {book.application_status === 'ongoing' &&
              book?.program_type !== 'writer_benefit_v3' &&
              book?.program_type !== 'writer_benefit_v3_us' &&
              book?.program_type !== 'writer_benefit_series' &&
              book.status !== 'draft' &&
              book.status !== 'disabled' ? (
                <MonthlyBookCard
                  book={book}
                  author_name={author_name}
                  monthly_reward_threshold={book.monthly_reward_threshold}
                  milestone_reward_threshold={book.milestone_reward_threshold}
                  handleViewStatusClick={handleViewStatusClick}
                  setTracker={handleSetTracker}
                  hiddenIds={hiddenIds}
                  hideCard={hideCardAfterView}
                />
              ) : (
                <NewBookCards
                  novelApply={novelApply}
                  bookDetails={book}
                  author_name={author_name}
                  history={history}
                  user={user}
                  signingStatus={signingStatus}
                  viewApplication={viewApplication}
                />
              )}
              {/* {book.application_status === 'ongoing' &&
          (book?.program_type === 'writer_benefit_v3' ||
            book?.program_type === 'writer_benefit_v3_us') &&
          book.status !== 'draft' &&
          book.status !== 'disabled' && (
            <DailyBonus
              bookDetails={book}
              author_name={author_name}
              history={history}
              user={user}
            />
          )} */}

              {(book.status === 'approved' || book.status === 'published') &&
                book?.program_type &&
                book?.program_type !== 'writer_benefit_v3' &&
                book?.program_type !== 'writer_benefit_v3_us' &&
                book?.program_type !== 'writer_benefit_series' &&
                (
                  <PerformanceCard bookId={book.book_id}  user={user} bookDetails={book}/>
                )}
            </React.Fragment>
          )}
          {WBPDetails && (
            <Contests
              user={user}
              bookList={WBPDetails.books}
              setIsShowAllContest={setIsShowAllContest}
              history={history}
              isShowAllContest={isShowAllContest}
              authorLanguage={user.languages || 'hindi'}
            />
          )}
        </Box>
      )}

      {isShowAllContest && (
        <Box {...widgetsContainer}>
          {WBPDetails && (
            <Contests
              user={user}
              authorVisibility={user.author_visibility}
              bookList={WBPDetails.books}
              setIsShowAllContest={setIsShowAllContest}
              history={history}
              isShowAllContest={isShowAllContest}
              authorLanguage={user.languages || 'hindi'}
            />
          )}
        </Box>
      )}
      {/* Footer */}
      <Footer />
    </>
  )
}
export default HomeUI
